import { createContext, useContext, useState, useEffect } from 'react';

const EnquiryCartContext = createContext(null);

export function EnquiryCartProvider({ children }) {
  const [items, setItems] = useState([]);

  // Load cart from localStorage on mount
  useEffect(() => {
    const saved = localStorage.getItem('enquiry_cart');
    if (saved) {
      try {
        setItems(JSON.parse(saved));
      } catch (e) {
        console.error('Failed to parse cart:', e);
      }
    }
  }, []);

  // Save cart to localStorage on change
  useEffect(() => {
    localStorage.setItem('enquiry_cart', JSON.stringify(items));
  }, [items]);

  const addItem = (item) => {
    setItems(prev => [...prev, { ...item, cartId: Date.now().toString() }]);
  };

  const removeItem = (cartId) => {
    setItems(prev => prev.filter(item => item.cartId !== cartId));
  };

  const updateItem = (cartId, updates) => {
    setItems(prev => prev.map(item => 
      item.cartId === cartId ? { ...item, ...updates } : item
    ));
  };

  const clearCart = () => {
    setItems([]);
    localStorage.removeItem('enquiry_cart');
  };

  const itemCount = items.length;

  return (
    <EnquiryCartContext.Provider value={{
      items,
      addItem,
      removeItem,
      updateItem,
      clearCart,
      itemCount,
    }}>
      {children}
    </EnquiryCartContext.Provider>
  );
}

export function useEnquiryCart() {
  const context = useContext(EnquiryCartContext);
  if (!context) {
    throw new Error('useEnquiryCart must be used within an EnquiryCartProvider');
  }
  return context;
}
